import { render, staticRenderFns } from "./TrainingItem.vue?vue&type=template&id=4ce06560"
import script from "./TrainingItem.vue?vue&type=script&lang=js"
export * from "./TrainingItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports